module.exports = __webpack_public_path__ + "static/media/360-1-1.924c580c.webp";